import { useFilterCompanies } from "@/providers/contexts";
import { Autocomplete } from "@/components/atoms";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";

// Only available to premium users
export const OperatingStatusFilter = () => {
  const { filters: companyFilters, dispatch, loading } = useFilterCompanies();

  const { selectedOperatingStatus } = companyFilters;

  const options: AutocompleteOption[] = [
    { key: "true", value: "Active" },
    { key: "false", value: "Inactive" },
  ];

  const selectedOptions = selectedOperatingStatus.map(status => {
    const matched = options.find(option => option.key === String(status));
    return {
      key: matched?.key ?? "",
      value: matched?.value ?? "",
    };
  });

  return (
    <Autocomplete
      componentName="operating-status"
      inputLabel="Operating Status"
      options={options}
      value={selectedOptions}
      multiple
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = selectedValues.map(opt => opt.key === "true");

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedOperatingStatus: selected },
        });
      }}
      loading={loading}
    />
  );
};
